/**
 * Accessibility options saved as cookie
 */
(function($) {
	$.accessibility = function(options) {
		if(typeof $.setCookie !== 'function') {
			console.warn('$.setCookie is not installed! Accessibility functionality will not work!');
			return;
		}

		options = $.extend({
			selector: '.menu .icon__',
			cookie: 'accessibility'
		}, options || {});

		var accessibility_options = {
				'font-size': ['regular', 'bigger'],
				'contrast-off': ['color', 'black']
			},
			accessibility = JSON.parse($.getCookie(options.cookie)) || {
				'font-size': 'regular',
				'contrast-off': 'color'
			};

		$.each(accessibility, function(key) {
			var $container = key === 'contrast-off' ? $('body') : $('html');
			$container.addClass('theme-' + accessibility[key]);

			$(options.selector + key).click(function() {
				var index = accessibility_options[key].indexOf(accessibility[key]),
					next_index = index + 1;

				if(next_index >= accessibility_options[key].length) {
					next_index = 0;
				}

				$container
					.removeClass('theme-' + accessibility_options[key][index])
					.addClass('theme-' + accessibility_options[key][next_index]);

				accessibility[key] = accessibility_options[key][next_index];
				$.setCookie(options.cookie, JSON.stringify(accessibility));

				return false;
			});
		});
	};
})(jQuery);